<h1>{{pageTitle}}</h1>

<mat-accordion>
  <mat-expansion-panel
    expanded="true"
    multi="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        FLOW STEPS
      </mat-panel-title>
    </mat-expansion-panel-header>
    <pdf-viewer [render-text]="true"
                [src]="stepsCreateDocDefaultsSrc"
                [zoom]="0.75"
                style="display: block;"
    ></pdf-viewer>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        FLOW DIAGRAM
      </mat-panel-title>
    </mat-expansion-panel-header>
    <pdf-viewer [render-text]="true"
                [src]="diagramCreateDocDefaultsSrc"
                [zoom]="0.75"
                style="display: block;"
    ></pdf-viewer>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEWS
      </mat-panel-title>
    </mat-expansion-panel-header>
    <figure>
      <figcaption>User highlights multiple text blocks using
        option-click-drag
      </figcaption>
      <img
        [src]="mockCreateDocDefaultsHighlightText"
        class="mid-size"/>
    </figure>
    <figure>
      <figcaption>User opens 'More' menu and selects 'Create
        Doc > Default Settings' from sub-menu
      </figcaption>
      <img
        [src]="mockCreateDocDefaultsMoreMenu"
        class="mid-size"/>
    </figure>
    <figure>
      <figcaption>System creates new Google Doc from selected text and
        default settings
      </figcaption>
      <img
        [src]="mockNewDocFromGmail"
        class="mid-size"/>
    </figure>
  </mat-expansion-panel>
</mat-accordion>
